const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://clockout.ngrok.dev';

export const createSessionAuthenticatedUrl = (clientId) => {
    return `${API_BASE_URL}/api/session/${clientId}/authenticated`;
};

export const createUpdateAccountUrl = (clientId, accountId = null) => {
    return accountId
        ? `${API_BASE_URL}/api/account/${clientId}/${accountId}`
        : `${API_BASE_URL}/api/account/${clientId}`;
};
